import { Tooltip as TooltipPrimitive } from '@mui/material';
import classnames from 'classnames';
import { useState } from 'react';

import styles from './Tooltip.module.scss';
import { TooltipProps } from './Tooltip.types';

export const Tooltip = ({
  slotProps,
  className,
  containerClassName,
  children,
  ...props
}: TooltipProps) => {
  const [open, setOpen] = useState(false);

  return (
    <TooltipPrimitive
      arrow
      open={props.disableHoverListener ? open : undefined}
      onClose={() => setOpen(false)}
      enterTouchDelay={props.disableHoverListener ? 0 : 200}
      slotProps={{
        ...slotProps,
        arrow: { ...slotProps?.arrow, className: styles.arrow },
        tooltip: { ...slotProps?.tooltip, className: classnames(styles.tooltip, className) },
      }}
      {...props}
    >
      <span
        className={classnames(styles.container, containerClassName)}
        onFocus={() => {
          if (props.disableHoverListener && !props.disableFocusListener) setOpen(true);
        }}
        onBlur={() => setOpen(false)}
        onClickCapture={() => setOpen(true)}
        data-tooltip="tooltip"
      >
        {children}
      </span>
    </TooltipPrimitive>
  );
};
